import { render, staticRenderFns } from "./expedientes.vue?vue&type=template&id=298d9a6c&"
import script from "./expedientes.vue?vue&type=script&lang=js&"
export * from "./expedientes.vue?vue&type=script&lang=js&"
import style0 from "./expedientes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports